/**
 * Compliance follow-up DTOs — shared between School Profile and Risk Triage.
 * Backend: /api/app/compliance-follow-up (ABP CrudAppService + custom actions).
 */

export const ComplianceFollowUpSource = {
  SchoolProfile: 1,
  RiskTriage: 2,
} as const;

export const ComplianceFollowUpStatus = {
  Open: 1,
  InReview: 2,
  Resolved: 3,
} as const;

export const ComplianceActivityType = {
  TakeAction: 1,
  AddReview: 2,
} as const;

export type ComplianceCreateScope =
  | { kind: 'school'; schoolId: string; reportingYear: number }
  | { kind: 'triage'; riskTriageQueueItemId: string; schoolId: string; reportingYear: number };

// ─── Input DTOs ───

export interface CreateComplianceFollowUpBody {
  source: number;
  schoolId?: string | null;
  reportingYear?: number | null;
  riskTriageQueueItemId?: string | null;
  description: string;
  deadline: string;
  currentStatus: number;
  activities: unknown[];
}

export interface TakeActionBody {
  newStatus: number;
  note: string;
}

export interface AddReviewBody {
  note: string;
}

export interface GetComplianceFollowUpListParams {
  schoolId?: string;
  riskTriageQueueItemId?: string;
  year?: number;
  source?: number;
  status?: number;
  skipCount?: number;
  maxResultCount?: number;
}

// ─── Output DTOs ───

export interface ComplianceActivityDto {
  id: string;
  complianceFollowUpId: string;
  type: number;
  note: string;
  newStatus: number | null;
  userName: string;
  creationTime: string;
  creatorId: string | null;
}

export interface ComplianceFollowUpDto {
  id: string;
  source: number;
  schoolId: string;
  schoolName: string | null;
  riskTriageQueueItemId: string | null;
  reportingYear: number;
  description: string;
  deadline: string;
  currentStatus: number;
  resolvedAt: string | null;
  creationTime: string;
  creatorId: string | null;
  creatorName: string | null;
  lastModificationTime: string | null;
  activities: ComplianceActivityDto[];
}

export interface ComplianceFollowUpListResponse {
  totalCount: number;
  items: ComplianceFollowUpDto[];
}
